import { render, staticRenderFns } from "./seperator.vue?vue&type=template&id=6ee1b2e9&"
import script from "./seperator.vue?vue&type=script&lang=js&"
export * from "./seperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports